import { render, staticRenderFns } from "./liaochang.vue?vue&type=template&id=62c62d98&scoped=true"
import script from "./liaochang.vue?vue&type=script&lang=js"
export * from "./liaochang.vue?vue&type=script&lang=js"
import style0 from "./liaochang.vue?vue&type=style&index=0&id=62c62d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c62d98",
  null
  
)

export default component.exports